import { t } from 'i18next';

import { ChipListCell, LinkCell } from 'core/elements';
import { AgGridFilterOption } from 'core/enums';
import { formatDate } from 'core/utils';
import { ICorporateUser } from 'corporate/types';
import { projectDetailsPath } from 'projects/routes/routePaths';
import { IProject } from 'projects/types';

import { ExternalCustomersCell } from './cells';
import { ProjectListColId } from './enums';

export const columnDef = () => [
  {
    colId: ProjectListColId.NAME,
    headerName: t('headerProjectName'),
    field: 'name',
    filter: 'agTextColumnFilter',
    cellRenderer: LinkCell,
    cellRendererParams: {
      getPath: (data: IProject) => projectDetailsPath(data.id),
    },
  },
  {
    colId: ProjectListColId.EXTERNAL_PROJECT_NUMBER,
    headerName: t('headerExternalProjectNumber'),
    field: 'externalProjectNumber',
    filter: 'agTextColumnFilter',
  },
  {
    colId: ProjectListColId.EXTERNAL_PROGRAM_NUMBER,
    headerName: t('headerExternalProgramNumber'),
    field: 'externalProgramNumber',
    filter: 'agTextColumnFilter',
  },
  {
    colId: ProjectListColId.EXTERNAL_PROJECT_CUSTOMERS,
    headerName: t('headerExternalCustomers'),
    field: 'externalProjectAccounts',
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: [AgGridFilterOption.CONTAINS],
    },
    sortable: false,
    minWidth: 300,
    width: 300,
    maxWidth: 450,
    cellRenderer: ExternalCustomersCell,
    cellRendererParams: {
      projectId: (data: IProject) => data.id,
    },
  },
  {
    colId: ProjectListColId.CORPORATE_USERS,
    headerName: t('headerUsers'),
    field: 'corporateUsers',
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: [AgGridFilterOption.CONTAINS],
    },
    sortable: false,
    valueGetter: ({ data }) =>
      data && data.corporateUsers.filter((user: ICorporateUser) => user.id != null),
    cellRenderer: ChipListCell,
    cellRendererParams: {
      getChipValue: (user: ICorporateUser) => user.name,
    },
  },
  {
    colId: ProjectListColId.VALID_SINCE,
    headerName: t('headerStartDate'),
    field: 'validSince',
    valueFormatter: ({ value }) => formatDate(value),
    filter: 'agDateColumnFilter',
    filterParams: {
      defaultOption: AgGridFilterOption.GREATER_THAN,
    },
  },
  {
    colId: ProjectListColId.VALID_UNTIL,
    headerName: t('headerEndDate'),
    field: 'validUntil',
    valueFormatter: ({ value }) => formatDate(value),
    filter: 'agDateColumnFilter',
    filterParams: {
      defaultOption: AgGridFilterOption.GREATER_THAN,
    },
  },
];
